<template>
    <v-card class="pa-5" :style="$vuetify.breakpoint.lgAndUp ? 'width:1134px' : ''">
        <v-form v-if="users_filters" @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('user_info_admin')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1 mb-5">{{$t("Редактировать профиль пользователя")}}</v-card-title>
            <v-layout column>
                <v-layout row>
                    <v-radio-group v-model="radioGroup" class="radio-row">
                        <v-radio
                            v-for="(status, i) in user_status"
                            :id="'radio'+i"
                            :key="i"
                            :value="i"
                            name="radio"
                            class="flex md4"
                        >
                            <labelTopic slot="label" :class="status.bg_color">{{ $t(status.text) }}</labelTopic>
                        </v-radio>
                    </v-radio-group>
                </v-layout>
                <v-layout row mt-4>
                    <v-flex mr-4 md4>
                        <div class="grey-text mb-2">{{$t("Роль")}}</div>
                        <v-select
                            :items="users_filters.roles"
                            solo
                            :value="role"
                            append-icon=""
                            :label="$t('Сделайте выбор')"
                            class="input"
                            @change="change_role"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex mr-4 md4>
                        <div class="grey-text mb-2">{{$t("Должность")}}</div>
                        <inputBase :value="position" :placeholder="$t('Введите текст')" @input="change_position" />
                    </v-flex>
                    <!-- <v-flex md4>
                        <div class="grey-text mb-2">{{$t("Тип подразделения")}}</div>
                        <v-select
                            :items="[1,2,3]"
                            solo
                            append-icon="expand_more"
                            :label="$t('Сделайте выбор')"
                            class="input"
                        />
                    </v-flex> -->
                    <v-flex mr-4 md4>
                        <div class="grey-text mb-2">{{$t("Организация")}}</div>
                        <v-autocomplete
                            :items="users_filters.organizations"
                            :value="company_name"
                            solo
                            append-icon=""
                            :label="$t('Сделайте выбор')"
                            class="input js-org input-autocomplete input-text-overflow"
                            @change="change_organization"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <!-- <v-layout row mt-4>
                    <v-flex mr-4 md4>
                        <div class="grey-text mb-2">{{$t("Организация")}}</div>
                        <v-select
                            :items="users_filters.organizations"
                            :value="other_user.company_name"
                            solo
                            append-icon="expand_more"
                            :label="$t('Сделайте выбор')"
                            class="input"
                        />
                    </v-flex>
                    <v-flex mr-4 md4>
                        <div class="grey-text mb-2">{{$t("Отдел")}}</div>
                        <v-select
                            :items="users_filters.departments"
                            solo
                            append-icon="expand_more"
                            :label="$t('Сделайте выбор')"
                            class="input"
                        />
                    </v-flex>
                    <v-flex md4 />
                </v-layout> -->
            </v-layout>
            <v-card-actions class="mt-5">
                <buttonRed @click.native="save_info">{{$t("Сохранить")}}</buttonRed>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
import labelTopic from '@/components/ui/labels/label_topic';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    inputBase,
    labelTopic,
  },
  data() {
    return {
      radio       : null,
      position    : '',
      user_role   : '',
      company_name: '',
      status      : '',
    };
  },
  computed: {
    ...mapGetters('profile/other_user', [
      'other_user',
    ]),
    role() {
      return this.get_role_by_id(this.other_user.role_id);
    },
    ...mapGetters('profile/modals', [
      'user_info',
      'user_info_admin',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('profile/other_user', [
      'other_user',
    ]),
    ...mapGetters('users/employees', [
      'users_filters',
      'get_role_by_id',
      'get_id_by_role',
      'get_id_by_organization',
    ]),
    ...mapGetters('profile/statuses', [
      'user_status',
      'status_active',
    ]),
    radioGroup: {
      get() {
        return this.user_status.findIndex((item)=>item.active);
      },
      set($event) {
        this.status = $event;
      },
    },
  },
  async beforeMount() {
    await this.get_users_filters();
  },
  mounted() {
    this.position = this.other_user.position;
    this.company_name = this.other_user.company_name;
    this.SET_CURRENT_STATUS();
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapActions('profile/user', [
      'save_user_info',
    ]),
    ...mapActions('users/employees', [
      'get_users_filters',
    ]),
    ...mapMutations('profile/modals', [
      'CLOSE_MODAL',
    ]),
    ...mapActions('profile/other_user', [
      'get_other_user',
    ]),
    ...mapActions('profile/statuses', [
      'SET_CURRENT_STATUS',
    ]),
    ...mapMutations('profile/statuses', [
      'SET_STATUS',
    ]),
    change_position(e) {
      this.position = e.target.value;
    },
    change_role(value) {
      this.user_role = this.get_id_by_role(value);
    },
    change_organization(value) {
      this.company_name = this.get_id_by_organization(value).text;
    },
    async save_info() {
      let obj = {};

      if (this.position) {
        obj.position = this.position;
      }

      if (this.user_role) {
        obj.role_id = this.user_role.id;
      }

      if (this.company_name) {
        obj.organization_id = this.get_id_by_organization(this.company_name).id;
      }

      if (this.status !== undefined && this.status !== '') {
        obj.status_id = this.user_status[this.status].id;
      }

      await this.save_user_info({id: this.$route.params.id, st: obj}, false);
      await this.get_other_user(this.$route.params.id);
      await this.SET_CURRENT_STATUS();
      this.CLOSE_MODAL('user_info_admin');
    },
  },
};
</script>
